export default __webpack_public_path__ + "static/media/ic-email.442b8185.svg";